module.exports = __webpack_public_path__ + "img/teeth-26.20facfdf.png";